import { hasAllAccess, isManager } from "./roles";

// Which config types each operational tier may EDIT. Advisory mirror of the
// backend enforcement (manager: PUT user_editable only; admin: everything).
export const ROLE_PERMISSIONS = {
  manager: ["user_editable"],
  admin: ["vector_store", "user_editable", "workflow", "prompts", "curated_cards"],
};

// Derive editable config types from role booleans. Roles are additive: a
// user holding several roles gets the union. Never collapse a user's roles
// to a single ROLE_PERMISSIONS[userRole] string lookup.
export const editableConfigTypesFor = (roles) => {
  const types = new Set();
  if (hasAllAccess(roles)) ROLE_PERMISSIONS.admin.forEach((t) => types.add(t));
  if (isManager(roles)) ROLE_PERMISSIONS.manager.forEach((t) => types.add(t));
  return [...types];
};
